import { getScrollElement } from './index.js';
function onViewportScroll(fn) {
    const viewport = getScrollElement();
    const scrollEventTarget = !viewport.parentElement ? window : viewport;
    scrollEventTarget.addEventListener('scroll', fn);
    return () => scrollEventTarget.removeEventListener('scroll', fn);
}
export default onViewportScroll;
//# sourceMappingURL=on-viewport-scroll.js.map